// ===============================
// Load Recommendations
// ===============================

async function loadCartRecommendations() {

    const container = document.querySelector('#cart-drawer-recommendations');

    if (!container) return;

    try {

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        if (!cart.items.length) {
            container.classList.add('hidden');
            container.innerHTML = '';
            return;
        }

        const cartProductIds = cart.items.map(item => item.product_id);

        let htmlToRender = null;

        // Try newest cart item first
        for (const item of [...cart.items].reverse()) {

            const response = await fetch(
                `/recommendations/products?section_id=cart-recommendations&product_id=${item.product_id}&intent=related`
            );

            if (!response.ok) continue;

            const html = await response.text();

            if (!html.trim()) continue;

            const temp = document.createElement('div');
            temp.innerHTML = html;

            // Remove products already in cart
            temp.querySelectorAll('[data-product-id]').forEach(card => {

                const productId = Number(card.dataset.productId);

                if (cartProductIds.includes(productId)) {
                    card.remove();
                }

            });

            // Do we still have recommendations?
            if (temp.querySelector('.recommendation-item')) {

                htmlToRender = temp.innerHTML;
                break;

            }

        }

        if (!htmlToRender) {
            console.log('No recommendations found.');
            return;
        }

        container.innerHTML = htmlToRender;
        container.classList.remove('hidden');


    } catch (error) {

        console.error('Cart Recommendations:', error);

        container.classList.add('hidden');

    }

}

// Make available globally
window.loadCartRecommendations = loadCartRecommendations;


// ===============================
// Recommendation Drag Scroll
// ===============================

(function () {

    let slider = null;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    document.addEventListener('mousedown', (e) => {

        slider = e.target.closest('.cart-recommendations-slider');

        if (!slider) return;

        // Allow normal interaction with controls
        if (
            e.target.closest('button') ||
            e.target.closest('a') ||
            e.target.closest('select') ||
            e.target.closest('input') ||
            e.target.closest('product-form')
        ) {
            slider = null;
            return;
        }

        isDragging = true;

        startX = e.clientX;
        scrollLeft = slider.scrollLeft;

        slider.classList.add('dragging');

    });

    document.addEventListener('mousemove', (e) => {

        if (!isDragging || !slider) return;

        e.preventDefault();

        const walk = e.clientX - startX;

        slider.scrollLeft = scrollLeft - walk;

    });

    document.addEventListener('mouseup', () => {

        if (!slider) return;

        slider.classList.remove('dragging');

        isDragging = false;
        slider = null;

    });

    document.addEventListener('mouseleave', () => {

        if (!slider) return;

        slider.classList.remove('dragging');

        isDragging = false;
        slider = null;

    });

})();


// ===============================
// Add Recommended Product
// ===============================

document.addEventListener('click', async (e) => {

    const button = e.target.closest('.recommendation-add');

    if (!button) return;

    const variantId = button.dataset.variantId;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {

        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        if (!addResponse.ok) {
            throw new Error('Unable to add product');
        }

        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {

            const response = await fetch('/?sections=cart-drawer');
            const data = await response.json();

            cartDrawer.renderContents({
                sections: {
                    'cart-drawer': data['cart-drawer']
                }
            });

            // Wait until drawer finishes rendering
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    window.loadCartRecommendations?.();
                });
            });

        }

    } catch (error) {

        console.error(error);

    } finally {

        button.disabled = false;
        button.textContent = 'Add To Cart';

    }

});


// ===============================
// Initial Load
// ===============================

loadCartRecommendations();